import React, { useRef, useEffect, useState } from "react";

export interface AnimatedSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  /** Root margin for intersection (e.g. "0px 0px -80px 0px" to trigger a bit before in view) */
  rootMargin?: string;
  /** Minimum fraction of element visible to trigger (0–1) */
  threshold?: number;
}

export function AnimatedSection({
  children,
  className = "",
  rootMargin = "0px 0px -60px 0px",
  threshold = 0.1,
  ...rest
}: AnimatedSectionProps): React.ReactElement {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) setVisible(true);
      },
      { rootMargin, threshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin, threshold]);

  return (
    <div
      ref={ref}
      className={`scroll-animate ${visible ? "is-visible" : ""} ${className}`.trim()}
      {...rest}
    >
      {children}
    </div>
  );
}

export default AnimatedSection;
